import * as ng from 'angular';

export const NumberDecimal = ($filter: ng.IFilterService, $parse: ng.IParseService, $timeout: ng.ITimeoutService) => (<angular.IDirective>{

    require: 'ngModel',

    link: (scope: any, element: JQLite, attrs: any, ngModelController: ng.INgModelController) => {
        let decimals = attrs.numberDecimal;
        let formatDecimal = (input) => {
            if (input !== undefined) {
                input = input.replace(',', '.');
                let exponent = Math.pow(10, decimals);
                let int = Math.round(input * exponent) / exponent;
                let res = parseFloat(int.toString()).toFixed(decimals);
                // keep only 2 decimal if are diff then 0
                if (decimals > 2 && res.indexOf('.') > -1) {
                    let splits = res.split('.');
                    if (splits.length === 2) {
                        let decimalsPart = splits[1];
                        for (let i = splits[1].length - 1; i >= 2; i--) {
                            if (splits[1][i] === '0') {
                                decimalsPart = decimalsPart.substring(0, decimalsPart.length - 1);
                            } else {
                                break;
                            }
                        }
                        res = splits[0] + '.' + decimalsPart;
                    }
                }
                return isNaN(Number(res)) ? '0.00' : res;
            }
        };
        ngModelController.$parsers.push((data) => {
            //                    x = formatDecimal(data);
            return formatDecimal(data);
        });
        ngModelController.$formatters.push((data) => {
            //                    y = formatDecimal(data);
            return formatDecimal(data);
        });
        element.bind('focus', (data) => {
            return formatDecimal(ngModelController.$modelValue);
        });
        element.bind('blur', () => {

            // apply formatting on the stored model value for display
            $timeout(() => {
                $(element).val(formatDecimal(element.val()));
            });
            //  element.val(formatDecimal(ngModelController.$modelValue));
        });
    }
});

NumberDecimal.$inject = ['$filter', '$parse', '$timeout'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/number-decimal/number-decimal.directive.ts